export enum Facet {
  Focuses = "focuses",
  Platforms = "platforms",
  Media = "media",
  Genders = "genders",
  Demography = "demography",
  Tones = "tones",
  Countries = "countries",
  Towns = "towns",
  Regions = "regions",
  Languages = "languages",
  Keywords = "keywords",
  Hashtags = "hashtags",
  Mentions = "keywordMentions",
  Entities = "namedEntities",
  Keyphrases = "keyphrases",
  InfluencersTags = "userTags",
  Favorites = "flag.favorite",
  Favorite = "favorite",
  Retweets = "flag.rt",
  UserUpdated = "flag.userUpdated",
  Trash = "flag.trash",
  Corpus = "corpora",
  MultiAuthor = "multi_author",
  AuthorType = "author",
  AuthorAge = "age",
  AuthorBirthday = "birthDate",
  ReviewRate = "rating",
  AuthorFollowers = "authorFollowers",
  Followers = "followers",
  CustomTags = "customTags",
  Query = "query",
  Topics = "categories",
  Emoji = "emoji",
  EmojiCharts = "emojiCharts",
  EmojiAnnotations = "emojiAnnotations",
  Affects = "affects",
  AffectsPositive = "affects_positive",
  AffectsNegative = "affects_negative",
  Occupations = "occupations",
  PictureWall = "picturewall",
  TwitterCertified = "verified",
  MaritalStatus = "maritalStatus",
  ResolvedEntities = "entities",
  Stories = "stories",
  Emotions = "emotions",
  FollowersFollowingsRatio = "followers_followings_ratio",
  ImageRecognition = "imageRecognition",
  ImageRecognitionScenes = "imageRecognitionScenes",
  ImageRecognitionPersons = "imageRecognitionPersons",
  ImageRecognitionGenders = "imageRecognitionGenders",
  ImageRecognitionObjects = "imageRecognitionObjects",
  ImageRecognitionAge = "imageRecognitionAgeGroups",
  ImageRecognitionEmotions = "imageRecognitionEmotions",
  ImageRecognitionPersonIdentifications = "imageRecognitionPersonIdentifications",
  ImageRecognitionLogos = "imageRecognitionLogos",
  SharedUrl = "sharedurl",
  Device = "device",
  Devices = "devices",
  DeviceDisplayNames = "deviceDisplayNames",
  DeviceOperatingSystems = "deviceOperatingSystems",
  DevicesPublishingMethods = "devicePublishingMethods",
  Retweeters = "retweeters",
  PostHeatmap = "postHeatmap",
  GeoHeatmap = "geoHeatmap",
  GeoFilter = "geoFilter",
  GeoArea = "geoArea",
  GeoLocations = "geoLocations",
  GeoTags = "geoTags",
  ProfileType = "profileType",
  AccountType = "accountType",
  SpamType = "spam-type",
  ContentClassification = "contentClassification",
  Franchise = "franchises",
  ProductRange = "product-ranges",
  Product = "eans",
  SignificantEntities = "significantEntities",
  SignificantHashtags = "significantHashtags",
  SignificantMentions = "significantMentions",
  SignificantNamedEntities = "significantNamedEntities",
  SignificantKeyphrases = "significantKeyphrases",
  EmergingHashtags = "emergingHashtags",
  EmergingMentions = "emergingMentions",
  EmergingNamedEntities = "emergingNamedEntities",
  EmergingKeyphrases = "emergingKeyphrases",
  GlobalTags = "globalTags",
  DocIds = "docIds",
}
